export const passportEs = {
  passport: {
    title: "Registro Digital de Parcela",
    subtitle: "Hoja de vida digital de tu parcela firmada con hash criptográfico (SHA-256), opcionalmente anclada en Polygon. No es un certificado emitido por una autoridad oficial.",
    generate: "Generar Pasaporte",
    generated: "Pasaporte generado",
    generatedDesc: "Se ha creado el pasaporte digital con hash SHA-256",
    certificateReady: "Registro digital listo",
    blockchainReady: "Listo para Blockchain",
    anchorBlockchain: "Anclar en Blockchain",
    anchored: "Anclado en Blockchain",
    climateRecords: "Registros Climáticos",
    cropSeasons: "Temporadas de Cultivo",
    fieldActivities: "Actividades de Campo",
    alerts: "Alertas e Incidentes",
    resolved: "resueltas",
    tabIdentity: "Identidad",
    tabClimate: "Clima",
    tabVegetation: "Vegetación",
    tabWater: "Balance Hídrico",
    tabActivities: "Actividades",
    tabPests: "Plagas",
    tabCerts: "Certificaciones",
    parcelIdentity: "Identidad de la Parcela",
    name: "Nombre",
    cropType: "Tipo de Cultivo",
    area: "Superficie",
    soilType: "Tipo de Suelo",
    irrigationType: "Tipo de Riego",
    plantingDate: "Fecha de Siembra",
    lat: "Latitud",
    lon: "Longitud",
    registeredSince: "Registrada desde",
    climateHistory: "Historial Climático",
    last90days: "Últimos 90 días de datos meteorológicos",
    vegetationIndices: "Índices de Vegetación",
    waterBalance: "Balance Hídrico y Coeficientes de Cultivo",
    fieldActivitiesTitle: "Registro de Actividades de Campo",
    recordedActivities: "actividades registradas",
    pestsDiseasesTitle: "Tratamientos de Plagas y Enfermedades",
    noPests: "Sin tratamientos fitosanitarios registrados — ¡excelente historial!",
    previousCerts: "Certificaciones Anteriores",
    ndviFromActivities: "NDVI registrado en actividades de campo",
    activity: "Actividad",
    before: "Antes",
    after: "Después",
    howToUseTitle: "¿Cómo usar tu Pasaporte Digital?",
    howStep1Title: "Integridad de datos",
    howStep1: "El hash SHA-256 garantiza que nadie puede alterar los datos. Cualquier cambio produce un hash diferente.",
    howStep2Title: "Anclar en blockchain",
    howStep2: "Opcionalmente, ancla los hashes de certificados seleccionados en Polygon para añadir un sello temporal público independiente. El anclaje es opt-in y se aplica solo a certificados seleccionados.",
    howStep3Title: "Seguros y auditorías",
    howStep3: "Presenta tu pasaporte como evidencia para reclamaciones de seguros, auditorías PAC/CAP o certificaciones de calidad.",
    howStep4Title: "Prefinanciación",
    howStep4: "Un historial verificado en blockchain aumenta la confianza de compradores e inversores en tu producción.",
    verifyLink: "Verificar este registro digital públicamente",
    shareVerification: "Compartir Enlace de Verificación",
    copied: "¡Enlace de verificación copiado!",
    institutional: {
      title: "Pasaporte de Evidencias",
      artifactType: "Instantánea de Evidencias del Ciclo de Cultivo",
      description: "Registro en un momento determinado de las evidencias disponibles para esta parcela y ciclo de cultivo. Distingue observaciones, declaraciones, resultados de modelos y evidencias ausentes.",
      ownerOnly: "Vista autenticada del propietario",
      selectRecord: "Seleccionar un registro de evidencias",
      cropSeason: "Ciclo de cultivo",
      selectSeason: "Seleccionar un ciclo de cultivo",
      snapshotHistory: "Historial de instantáneas",
      selectSnapshot: "Seleccionar una instantánea",
      latest: "Más reciente",
      loadingSnapshots: "Cargando instantáneas almacenadas…",
      emptyTitle: "No hay ninguna Instantánea de Evidencias disponible para este ciclo de cultivo.",
      emptyDescription: "Esta vista no crea instantáneas automáticamente.",
      summaryTitle: "Resumen de evidencias",
      entriesTitle: "Entradas de evidencia",
      entriesDescription: "Despliega una entrada para consultar su fuente, procedencia, calidad y limitaciones almacenadas.",
      missingTitle: "Evidencia ausente",
      missingDescription: "La evidencia no disponible, insuficientemente acreditada, obsoleta, no compatible o bloqueada en el momento de la instantánea permanece explícitamente ausente.",
      notAvailable: "No disponible en esta instantánea",
      limitationsTitle: "Limitaciones",
      limitationsDescription: "Limitaciones completas almacenadas para esta instantánea inmutable.",
      integrityTitle: "Integridad del registro",
      integrityClaim: "El resumen SHA-256 permite a SentinelCrop detectar si la carga almacenada de esta instantánea difiere de la carga representada por el resumen.",
      integrityBoundary: "Este resumen no acredita verdad agronómica, validación de campo, exactitud de declaraciones o mediciones, rendimiento, cosecha, existencia de mercancía, cadena de custodia, resultados de carbono ni certificación de terceros.",
      digestMatch: "El resumen de la carga coincide con el hash almacenado",
      digestMatchDescription: "El navegador canonizó la carga almacenada devuelta con el contrato de integridad existente y reprodujo el resumen almacenado.",
      digestWarning: "Advertencia de integridad de la carga",
      digestWarningDescription: "La carga almacenada devuelta no reprodujo el resumen almacenado. Motivo: {{reason}}. La instantánea no se ha alterado.",
      digestChecking: "Comprobando el resumen de la carga",
      digestCheckingDescription: "Canonizando la carga almacenada devuelta y comparando su resumen.",
      byClass: "Por clase de evidencia",
      byOrigin: "Por origen de evidencia",
      noneRecorded: "Ninguno registrado en esta instantánea.",
      unknown: "Desconocido",
      canonicalSemantics: "Semántica canónica",
      fields: {
        contractVersion: "Versión del contrato", attribute: "Atributo", value: "Valor almacenado", unit: "Unidad",
        entryClass: "Clase de evidencia", evidenceOrigin: "Origen de evidencia",
        verificationStatus: "Estado de verificación", sourceSystem: "Fuente", sourceRecordId: "ID del registro fuente",
        observedAt: "Observado el", recordedAt: "Registrado el", quality: "Nivel de calidad", qualityNotes: "Notas de calidad",
        valueReference: "Referencia del valor", reason: "Motivo", expectedSource: "Fuente esperada", cropSeason: "Ciclo de cultivo",
        cropSeasonStart: "Inicio del ciclo", snapshotId: "ID de instantánea", snapshotVersion: "Versión de instantánea",
        asOf: "Instantánea a fecha de", createdAt: "Creada el", integrityAlgorithm: "Algoritmo de integridad", integrityHash: "Hash de integridad completo",
      },
      enums: {
        FACT_OBSERVATION: "Observación de hecho", DECLARATION: "Declaración", REFERENCE_DATA: "Datos de referencia",
        MODEL_OUTPUT: "Resultado de modelo", HUMAN_REVIEW: "Revisión humana", MISSING_UNKNOWN: "Ausente / desconocido",
        SATELLITE_VERIFIED: "Verificado por satélite", FIELD_MEASURED: "Medido en campo", LAB_VERIFIED: "Verificado en laboratorio",
        DOCUMENT_VERIFIED: "Verificado por documento", PRODUCER_DECLARED: "Declarado por el productor", MODELLED: "Modelizado",
        NOT_VERIFIED: "No verificado", SOURCE_BACKED: "Respaldado por fuente", SELF_REPORTED: "Autodeclarado",
        REFERENCE_ONLY: "Solo referencia", UNVERIFIED: "No verificado", BLOCKED: "Bloqueado",
        NO_SOURCE_RECORD: "Sin registro fuente", STALE: "Obsoleto", BLOCKED_BY_CONTRACT: "Bloqueado por contrato",
        INSUFFICIENT_PROVENANCE: "Procedencia insuficiente", UNSUPPORTED_SOURCE: "Fuente no compatible", NEVER_COLLECTED: "Nunca recopilado",
        high: "Alta", medium: "Media", low: "Baja", unknown: "Desconocida", planning: "Planificación", active: "Activo",
        harvested: "Cosechado", cancelled: "Cancelado",
      },
      limitations: {},
      errors: {
        authRequired: "Se requiere una sesión autenticada del propietario.", parcels: "No se pudieron cargar las parcelas.",
        seasons: "No se pudieron cargar los ciclos de cultivo.", snapshots: "No se pudieron cargar las Instantáneas de Evidencias almacenadas.",
      },
    },
  },
  verify: {
    authority: "Proveedor del Algoritmo",
    title: "Verificación de Registro Digital",
    subtitle: "Introduce un hash SHA-256 para verificar la integridad de un registro digital de Sentinel Crop. Es una comprobación de integridad de datos, no la verificación de un certificado oficial.",
    placeholder: "0x... (hash SHA-256)",
    verify: "Verificar",
    verified: "Registro Digital Verificado ✓",
    verifiedDesc: "Este registro digital fue generado por Sentinel Crop y sus datos no han sido alterados desde su emisión. Sentinel Crop no es una autoridad de certificación.",
    notVerified: "Registro Digital No Encontrado",
    notVerifiedDesc: "Ningún registro coincide con este hash. Puede haber sido alterado o no existir.",
    certType: "Tipo de Registro",
    issuedAt: "Fecha de Emisión",
    issuer: "Proveedor del Algoritmo",
    certId: "ID del Registro",
    dataHash: "Hash de Integridad (SHA-256)",
    parcelInfo: "Parcela Registrada",
    blockchainProof: "Prueba Blockchain",
    network: "Red",
    blockNumber: "Número de Bloque",
    txHash: "Hash de Transacción",
    viewOnExplorer: "Ver en Polygonscan",
    howItWorks: "¿Cómo funciona la verificación?",
    step1: "Todos los datos agronómicos se hashean con SHA-256, creando una huella criptográfica única.",
    step1b: "Cada certificado incluye los IDs originales de las fuentes de datos (Copernicus, AEMET, SoilGrids) para que cualquiera pueda verificar los datos crudos de forma independiente.",
    step2: "El hash puede anclarse opcionalmente en la red Polygon para certificados seleccionados, añadiendo un sello temporal público independiente.",
    step3: "Cualquier persona con el hash puede verificar que los datos no han sido alterados desde la certificación.",
    provenanceTitle: "Fuentes de Datos y Verificación Independiente",
    provenanceDesc: "Cada fuente de datos puede verificarse de forma independiente haciendo clic en el enlace externo. No confíes — verifica.",
    srcSatellite: "Imágenes Satelitales",
    srcWeather: "Datos Meteorológicos",
    srcSoil: "Datos de Suelo",
    srcAlgorithm: "Algoritmo de Cálculo",
    verifySource: "Verificar ↗",
    lastAcquisition: "Última adquisición",
    resolution: "Resolución",
    footerTrust: "No confíes. Verifica. — Todas las fuentes de datos son auditables de forma independiente.",
  },
};
